import {
	CheckinOrderFragment,
	CheckoutOrderFragment,
	GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	GdsServiceVipSubType,
	OrderAdditionalServiceGdsServiceServiceType,
	VipServiceFragment
} from '@websky/graphql';
import flatten from 'lodash/flatten';

import { State } from './types';
import { isCheckoutOrderGuard } from '../../typeguards';

export const upgradeClassStateFactory = (order: CheckoutOrderFragment | CheckinOrderFragment): State => {
	const state: Partial<State> = {
		orderId: order.id,
		service: null,
		selectedSegments: [],
		step: 'select',
		travellersIds: [],
		flights: []
	};

	const orderCurrency = order.price.total.currency;

	state.service = order.additionalServices?.gdsServices?.services?.find(
		service =>
			service.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
			(service as VipServiceFragment).subType === GdsServiceVipSubType.Upgrade
	) as GdsService_OrderAdditionalServiceGdsServiceVip_Fragment;

	if (isCheckoutOrderGuard(order)) {
		state.flights = order.flight.segmentGroups.map(group => {
			return {
				...group,
				segments: group.segments.filter(segment => {
					return (
						flatten(state.service.allowedSegments).includes(segment.id) && segment.subStatus !== 'Upgrade'
					);
				}),
				flightId: order.flight.id
			};
		});
	} else {
		state.flights = order.segments;
	}

	state.travellersIds = order.travellers.map(traveller => traveller.id);

	state.totalPrice = {
		amount: 0,
		currency: orderCurrency
	};

	return state as State;
};
